import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

export default function EvaluationHero({ mode, loading, hasData, periodLabel, onRefresh, onPrint, onDownload }) {
    return (
        <Box
            sx={{
                borderBottom: '1px solid',
                borderColor: 'divider',
                background: 'linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)',
                py: { xs: 3, md: 4 },
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={2}
                    alignItems={{ xs: 'flex-start', md: 'center' }}
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
                            Steuerliche Auswertung
                        </Typography>
                        <Typography variant="subtitle1" sx={{ mt: 0.5, maxWidth: 860 }}>
                            USt-Voranmeldung, USt-Jahreserklärung und Einkommensteuer - einheitlich aufbereitet und druckbar.
                        </Typography>
                        {periodLabel && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                                Aktueller Zeitraum: {periodLabel}
                            </Typography>
                        )}
                    </Box>
                    <Stack direction="row" spacing={1.5} data-evaluation-actions="true">
                        <Button
                            variant="contained"
                            startIcon={<DownloadRoundedIcon />}
                            onClick={onDownload}
                            disabled={loading || !hasData}
                        >
                            PDF
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<PrintRoundedIcon />}
                            onClick={onPrint}
                            disabled={loading || !hasData}
                        >
                            Drucken
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<RefreshRoundedIcon />}
                            onClick={onRefresh}
                            disabled={loading || !mode}
                        >
                            Neu berechnen
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
